import { useContext } from 'react'
import DialogStackContext from './DialogStackContext'

export default function useCrmDialogs() {
  return useContext(DialogStackContext)
}
